<div class="relative w-screen h-screen overflow-hidden">
	<canvas
		class="block cursor-crosshair active:cursor-grabbing"
		#canvas
		(mousedown)="onMouseDown($event)"
		(mousemove)="onMouseMove($event)"
		(mouseup)="onMouseUp($event)"
		(mouseleave)="onMouseUp($event)"
		(wheel)="onWheel($event)"
		(touchstart)="onTouchStart($event)"
		(touchmove)="onTouchMove($event)"
		(touchend)="onTouchEnd($event)"
		(touchcancel)="onTouchEnd($event)">
	</canvas>
</div>
